import FinishProposalCreated from './FinishProposalCreated';

export default FinishProposalCreated;
